module.exports = "<ea-card-details-page></ea-card-details-page>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaSettings/eaCardDetails/eaCardDetailsPage/eaCardDetailsPageModule.tpl.html
// module id = 1049
// module chunks = 12